import { ColumnManager } from '../../../../utils/ColumnManager'

export const HEADER_FIELD_NAMES = {
  torioiki: '取置',
  basho: '場所',
  edaban: '枝番'
}

export const HEADER_INPUT_STYLE = {
  width: '100%',
  height: '40px',
  background: '#fff',
  padding: '4px',
  textAlign: 'center',
  fontSize: '12px',
  outline: 'none',
  borderColor: 'transparent'
}

export const EMPTY_CONTEXT_MENU = {
  show: false,
  x: 0,
  y: 0,
  type: null,
  data: null
}

export const HEADER_FIELDS = [
  {
    key: 'torioiki',
    label: '取置',
    defaultOverride: (col, columnManager, selectedItems) => {
      return null
    }
  },
  {
    key: 'basho',
    label: '場所',
    defaultOverride: (col, columnManager, selectedItems) => {
      return null
    }
  },
  {
    key: 'edaban',
    label: '枝番',
    defaultOverride: (col, columnManager) => {
      if (col.type === 'black-circle') return 'SP'
      const saved = columnManager?.getCustomerHeaderField(
        col.customerCode,
        'edaban'
      )
      if (saved !== undefined && saved !== '') return saved
      const { branchCode } = ColumnManager.parseColumnKey(col.customerCode)
      return branchCode || ''
    }
  }
]
